import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const i18nReady = i18next
.use(HttpApi)
.use(LanguageDetector)
// connect with React
.use(initReactI18next)
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
	fallbackLng: 'en',
	interpolation: {
		escapeValue: false, // not needed for react as it escapes by default
	},
	backend: {
		loadPath: '/locales/{{lng}}.json'
	}
});

console.log('i18nReady instance', i18nReady)

window.i18n = i18next;

export const i18n = i18next;

export default i18next; // eslint-disable-line
